import React from 'react';
import Modal from '../../components/Modal';

const formatCurrencyValue = (value) => {
  if (!value && value !== 0) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
};

export default function ViewSaleModal({ sale, isOpen, onClose }) {
  if (!sale) return null;

  const title = (
    <div style={{
      background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
      margin: '-24px -24px 0 -24px',
      padding: '24px',
      borderRadius: '12px 12px 0 0',
      borderBottom: '2px solid rgba(255, 255, 255, 0.1)'
    }}>
      <h2 style={{
        margin: '0',
        color: '#ffffff',
        fontSize: '24px',
        fontWeight: '700',
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        <i className="fas fa-receipt" style={{ fontSize: '22px' }} />
        Venda
      </h2>
      <p style={{
        margin: '8px 0 0 0',
        color: 'rgba(255, 255, 255, 0.85)',
        fontSize: '13px',
        fontWeight: '500'
      }}>
        #{sale.id}
      </p>
      <p style={{
        margin: '4px 0 0 0',
        color: 'rgba(255, 255, 255, 0.85)',
        fontSize: '14px'
      }}>
        <i className="fas fa-calendar-alt" style={{ marginRight: '8px' }} />
        {formatDate(sale.saleDate)}
      </p>
    </div>
  );

  const footer = (
    <button
      onClick={onClose}
      type="button"
      style={{
        background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
        border: 'none',
        color: '#ffffff',
        padding: '10px 24px',
        borderRadius: '8px',
        fontWeight: '600',
        fontSize: '14px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)'
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = 'translateY(-2px)';
        e.target.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'translateY(0)';
        e.target.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
      }}
    >
      Fechar
    </button>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} footer={footer}>
      {/* Items Section */}
      <div style={{ marginBottom: '24px' }}>
        <h3 style={{
          color: '#f29205',
          fontSize: '18px',
          fontWeight: '600',
          margin: '0 0 16px 0',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <i className="fas fa-shopping-cart" />
          Itens da Venda
        </h3>
        <div style={{
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '8px',
          border: '1px solid rgba(242, 146, 5, 0.2)',
          overflow: 'hidden'
        }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse'
          }}>
            <thead>
              <tr style={{
                background: 'rgba(242, 146, 5, 0.1)',
                borderBottom: '2px solid rgba(242, 146, 5, 0.3)'
              }}>
                <th style={{
                  padding: '12px',
                  textAlign: 'left',
                  color: '#f29205',
                  fontWeight: '600',
                  fontSize: '14px'
                }}>Produto</th>
                <th style={{
                  padding: '12px',
                  textAlign: 'center',
                  color: '#f29205',
                  fontWeight: '600',
                  fontSize: '14px'
                }}>Qtd</th>
                <th style={{
                  padding: '12px',
                  textAlign: 'center',
                  color: '#f29205',
                  fontWeight: '600',
                  fontSize: '14px'
                }}>Preço Unit.</th>
                <th style={{
                  padding: '12px',
                  textAlign: 'right',
                  color: '#f29205',
                  fontWeight: '600',
                  fontSize: '14px'
                }}>Total</th>
              </tr>
            </thead>
            <tbody>
              {sale.items && sale.items.map((item, index) => (
                <tr key={index} style={{
                  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                  transition: 'background 0.2s ease'
                }}>
                  <td style={{
                    padding: '12px',
                    color: '#e0e0e0',
                    fontSize: '14px'
                  }}>
                    {item.product ? (
                      item.product.brand 
                        ? `${item.product.name} - ${item.product.brand}`
                        : item.product.name
                    ) : (
                      'Produto não encontrado'
                    )}
                  </td>
                  <td style={{
                    padding: '12px',
                    textAlign: 'center',
                    color: '#e0e0e0',
                    fontSize: '14px'
                  }}>
                    {item.quantity}
                  </td>
                  <td style={{
                    padding: '12px',
                    textAlign: 'center',
                    color: '#e0e0e0',
                    fontSize: '14px'
                  }}>
                    {formatCurrencyValue(item.unitPrice)}
                  </td>
                  <td style={{
                    padding: '12px',
                    textAlign: 'right',
                    color: '#e0e0e0',
                    fontWeight: '600',
                    fontSize: '14px'
                  }}>
                    {formatCurrencyValue(item.total)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Observation */}
      {sale.observation && (
        <div style={{ marginBottom: '24px' }}>
          <h3 style={{
            color: '#f29205',
            fontSize: '18px',
            fontWeight: '600',
            margin: '0 0 12px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <i className="fas fa-sticky-note" />
            Observação
          </h3>
          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '8px',
            padding: '16px',
            border: '1px solid rgba(242, 146, 5, 0.2)',
            color: '#e0e0e0',
            fontSize: '14px',
            lineHeight: '1.6'
          }}>
            {sale.observation}
          </div>
        </div>
      )}

      {/* Totals Section */}
      <div style={{
        background: 'rgba(242, 146, 5, 0.1)',
        borderRadius: '8px',
        padding: '20px',
        border: '1px solid rgba(242, 146, 5, 0.3)'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '12px'
        }}>
          <span style={{ color: '#b0b0b0', fontSize: '14px' }}>Subtotal:</span>
          <span style={{ color: '#e0e0e0', fontSize: '16px', fontWeight: '500' }}>
            {formatCurrencyValue(sale.subtotal)}
          </span>
        </div>
        {sale.discount > 0 && (
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '12px'
          }}>
            <span style={{ color: '#b0b0b0', fontSize: '14px' }}>Desconto:</span>
            <span style={{ color: '#ff6b6b', fontSize: '16px', fontWeight: '500' }}>
              - {formatCurrencyValue(sale.discount)}
            </span>
          </div>
        )}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: '12px',
          borderTop: '2px solid rgba(242, 146, 5, 0.3)'
        }}>
          <span style={{ color: '#f29205', fontSize: '18px', fontWeight: '700' }}>Total:</span>
          <span style={{
            color: '#f29205',
            fontSize: '24px',
            fontWeight: '700'
          }}>
            {formatCurrencyValue(sale.total)}
          </span>
        </div>
      </div>
    </Modal>
  );
}




